import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { Toast, ToastService, ToastType } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './toast.component.html'
})
export class ToastComponent implements OnInit {
  toasts: Toast[] = [];

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.toasts$.subscribe((toasts) => {
      this.toasts = toasts;
    });
  }

  dismiss(id: number): void {
    this.toastService.dismiss(id);
  }

  icon(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'CheckCircle';
      case 'error':
        return 'XCircle';
      case 'warning':
        return 'TriangleAlert';
      default:
        return 'Info';
    }
  }

  borderClass(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'border-emerald-200';
      case 'error':
        return 'border-rose-200';
      case 'warning':
        return 'border-amber-200';
      default:
        return 'border-sky-200';
    }
  }

  iconClass(type: ToastType): string {
    switch (type) {
      case 'success':
        return 'text-emerald-500';
      case 'error':
        return 'text-rose-500';
      case 'warning':
        return 'text-amber-500';
      default:
        return 'text-sky-500';
    }
  }
}
